import { Box } from '@mui/material';
import { Typography, colors, Avatar, IconGraphy } from '@leapeasy/ui-kit';
import { getDemoData } from 'utils/helpers';
import { DetailItem } from './DetailItem';

const NO_DATA = 'No Data';

const displayValue = (value, isDemo, demoKey) => {
  if (isDemo && demoKey) return getDemoData(demoKey);
  if (value === null || value === undefined || String(value).trim() === '') return NO_DATA;
  return value;
};

const formatCreatedDate = (value, isDemo) => {
  if (isDemo) return '2024-06-04';
  if (!value) return NO_DATA;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toISOString().slice(0, 10);
};

const formatCount = (value, isDemo) => {
  if (isDemo) return '12';
  if (value === null || value === undefined || value === '') return '0';
  return String(value);
};

export const DetailCard = ({ landlord, isDemo }) => {
  if (!landlord) return null;

  const user = landlord.user || null;
  const userImage = user?.image;

  const name = displayValue(landlord.name, isDemo, 'landlord-name');
  const accountName = displayValue(landlord.name, isDemo, 'account-name');
  const jobTitle = isDemo ? getDemoData('username') : user?.job_title?.trim() || 'Operator';
  const propertyCount = formatCount(landlord.total_buildings, isDemo);
  const phone = displayValue(landlord.phone || user?.phone, isDemo, 'phone');
  const email = displayValue(landlord.email_address, isDemo, 'email');
  const primaryContact = displayValue(landlord.primary_contact, isDemo, 'primary-contact');
  const billingCountry = displayValue(landlord.billingCountry, isDemo, 'address-country');
  const billingPostalCode = displayValue(landlord.billingPostalCode, isDemo, 'address-postcode');
  const billingState = displayValue(landlord.billingState, isDemo, 'address-state');
  const billingStreet = displayValue(landlord.billingStreet, isDemo, 'address-street');
  const createdDate = formatCreatedDate(landlord.sf_createdDate || landlord.createdAt, isDemo);
  const unitCount = formatCount(landlord.total_units ?? landlord.number_of_units, isDemo);

  return (
    <Box
      display={'flex'}
      flexWrap={'wrap'}
      borderRadius={2}
      py={2}
      backgroundColor="rgba(248, 244, 249, 0.48)"
      border="1px solid #F8F4F9"
    >
      <Box flexGrow={1} fontWeight={500} borderRight={`1px solid ${colors.purple[200]}`}>
        <Box width="fit-content" marginLeft="20px" paddingTop="2px" whiteSpace="nowrap">
          <Avatar
            size="x-large"
            iconImage={
              userImage ? <img src={userImage} alt="" /> : <IconGraphy icon="Users.User" />
            }
          />
        </Box>
        <Box width="fit-content" marginLeft="20px" paddingTop="15px" whiteSpace="nowrap">
          <Typography variant="body3" style={{ color: colors.black[600], marginBottom: 8 }}>
            Name
          </Typography>
          <Typography variant="body3" style={{ color: colors.purple[900] }}>
            {name}
          </Typography>
        </Box>
        <Box width="fit-content" marginLeft="20px" paddingTop="15px" whiteSpace="nowrap">
          <Typography variant="body3" style={{ color: colors.black[600], marginBottom: 8 }}>
            Account Name
          </Typography>
          <Typography variant="body3" style={{ color: colors.purple[900] }}>
            {accountName}
          </Typography>
        </Box>
      </Box>
      <DetailItem label={['Job Title', 'Property Count']} value={[jobTitle, propertyCount]} />
      <DetailItem
        label={['Phone Number', 'Email Address', 'Primary Contact']}
        value={[phone, email, primaryContact]}
      />
      <DetailItem
        label={['Billing Country', 'Billing Postal Code', 'Billing State']}
        value={[billingCountry, billingPostalCode, billingState]}
      />
      <DetailItem
        label={['Billing Street', 'Created Date', 'Unit Count']}
        value={[billingStreet, createdDate, unitCount]}
        isLastItem
      />
    </Box>
  );
};
